import { MetricValue } from 'components/RoasValue.jsx';
/**
 * A single figure in the stats grid.
 *
 * `tone` maps to the colour classes the stylesheet already defines
 * (green / red / yellow / purple / blue / orange) rather than an inline colour,
 * so the three themes can each pick their own palette.
 */
export default function StatCard({ label, value, sub, tone, ...rest }) {
  return (
    <div className="stat-card" {...rest}>
      <div className="label">{label}</div>
      <div className={['value', tone].filter(Boolean).join(' ')}><MetricValue label={label} value={value} /></div>
      {sub && <div className="sub">{sub}</div>}
    </div>
  );
}
